module.exports = __webpack_public_path__ + "sv.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/sv.svg
// module id = 822
// module chunks = 0